import React from 'react'
import { Link } from 'react-router-dom'

const Button = ({children, active, linkto}) => {
  return (
    <Link to={linkto}>
        <div className={`text-center text-lg px-6 py-3 rounded-md font-semibold
        ${active ? "bg-yellow-50 text-black" : "bg-richblack-800"} hover:scale-95 transition-all duration-200
        shadow-box`}>
            {children}
        </div>
    </Link>
  )
}

export default Button